import {useLazyQuery, gql} from "@apollo/client";
import {useContext} from "react";
import {LocaleContext} from "../store/providers/LocaleProvider";
import {useLogger} from "./useLogger";

const QUERY = gql`
query getCountrySEOBySlug($slug: String!, $locale: String!) {
  countryCollection(limit: 1, where: { slug: $slug }, locale: $locale) {
    items{
      countrySeo{
        title
        description
        noIndex
        noFollow
      }
    }
  }
}
`;

export const useCountrySEOBySlug = () => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {logger} = useLogger();
    const [getCountrySEO, {loading, error, data}] = useLazyQuery(QUERY, {
        errorPolicy: "all"
    });
    const fetchCountrySEOData = (slug) => {
        if (slug) {
            getCountrySEO({ variables: { slug, locale: localeUppercase } });
        }
    };
    
    if (error?.message) {
        logger(error?.message, "error", "useCountrySEOBySlug", error?.stack);
    }

    const countrySEOData = data?.countryCollection?.items[0]?.countrySeo;

    return {
        fetchCountrySEOData,
        countrySEOData,
        loading,
        error
    };
};
